export default {
      id: "icon-warning-usage",
      viewBox: "0 0 16 16",
      url: "/" + "sprite.svg#icon-warning",
      toString: function () {
        return this.url;
      }
    }